import { render } from "./MantenedorAsignaturas.vue?vue&type=template&id=40e3035f"
import script from "./MantenedorAsignaturas.vue?vue&type=script&lang=js"
export * from "./MantenedorAsignaturas.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__